import * as THREE from 'three';
import Experience from '../Experience';

export default class Moon {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.moon = null;



    this.load();

    
    console.log(this.experience.world)
  
}

  load() {
    const moonTexture = new THREE.TextureLoader().load('../textures/moon/moon.jpg');
    const normalTexture = new THREE.TextureLoader().load('../textures/moon/normal.jpg');

    this.moon = new THREE.Mesh(
      new THREE.SphereGeometry(0.4, 32, 32),
      new THREE.MeshStandardMaterial({
        map: moonTexture,
        normalMap: normalTexture,
        normalScale: new THREE.Vector2(0.1, 0.1),
      })
    );

    this.moon.position.x = 2
    this.moon.position.y = -4

    this.scene.add(this.moon);
  }

  rotate() {
    if (this.moon) {
      // this.moon.rotation.x += 0.0125;
      this.moon.rotation.y += 0.0125;
      //this.moon.rotation.z += 0.0125;
    }
  }
}